import * as firebase from 'firebase';
var config = {
  apiKey: "AIzaSyCvdmcmSYKUlmnuoHuHmig1mGhwHYLy8H0",
  authDomain: "envelope-85837.firebaseapp.com",
  databaseURL: "https://envelope-85837.firebaseio.com",
  projectId: "envelope-85837",
  storageBucket: "envelope-85837.appspot.com",
  messagingSenderId: "882082978361"
};
firebase.initializeApp(config);

// ACCEPT TERMS & CONDITIONS
export function fireCheckAcceptTerms() {
  return firebase.database().ref().child('/users/' + firebase.auth().currentUser.uid)
    .once('value').then(function(snapshot) {
      return snapshot.val();
    })
}

export function fireAcceptTerms() {
  return firebase.database().ref().child('/users/' + firebase.auth().currentUser.uid)
    .update({ acceptedTerms: true })
    .then(function(res) {
      return res;
    })
}

// AUTHENTICATION
export function authed() {
  return firebase.auth().currentUser;
}

export function isMine(authorId) {
  return firebase.auth().currentUser && firebase.auth().currentUser.uid === authorId;
}

export function amPremium() {
  // if (!firebase.auth().currentUser) { return false; }
  return firebase.database().ref().child('/users/' + firebase.auth().currentUser.uid)
    .once('value').then(function(snapshot) {
      return snapshot.val();
    })
}

export const fireAuth = firebase.auth();

export function fireSignOut() {
  return new Promise((resolve, reject) => {
    return firebase.auth().signOut().then(function(error) {
      if (typeof error === "undefined") { resolve("success") }
      else { reject(error) }
    })
  })
}

export function fireSignIn(role, industry) {
  localStorage.setItem("role", role);
  localStorage.setItem("industry", industry);
  var provider = new firebase.auth.GoogleAuthProvider();
  firebase.auth().signInWithRedirect(provider);
  // firebase.auth().getRedirectResult().subscribe(auth => {
    // if(auth) {
    //               console.log(auth);
    //             } else {
    //               console.log('User Not Logged In');
    //             }
  // })
    // .then(res => { console.log('SUCCESS', res, role, industry)});
}

// GETTERS
export function getEnvelopeDetails(key, hot) {
  var ref = firebase.database().ref().child('/full-envelopes/' + key)
  return ref.once('value')
   .then(function(snap) {
      const env = snap.val();
      if (env) {
        env.table = firebaseToRealArray(env.table);
        env.libraries = JSON.parse(env.libraries);
        ref.off();
        return env
      } else {
        // DO NOTHING
      }
    })
}


export const publicMail = firebase.database().ref().child('/public-envelopes/');
export function myMail(user) {
  return firebase.database().ref().child('/user-envelopes/' + user.uid)
}
// export const myMail = firebase.database().ref().child('/user-envelopes/'); //  + firebase.auth().currentUser.uid

export function snapToArrayWithKeys(snap) {
  var a = [];
  snap.forEach(function(item) {
    var env = item.val(); env.key = item.key;
    // if (typeof property !== "undefined") { env[property] = item[property]; }
    a.push(env)
  })
  return a;
}


// export function getPublicMail() {
//   return firebase.database().ref().child('/public-envelopes/')
//   // .on('value', function(snap) {
//   //   var metaEnvelopes = [];
//   //   snap.forEach(function(item) {
//   //     var env = item.val(); env.key = item.key;
//   //     metaEnvelopes.push(env)
//   //   })
//   //   this.setState({ metaEnvelopes })
//   // }.bind(this))
// }








//////
export function deleteEnvelope(key, db) {
  var uid = firebase.auth().currentUser.uid;
  var updates = {};
  updates['/user-envelopes-meta/' + uid + '/' + key] = null;
  updates['/public-envelopes-meta/' + key] = null;
  updates['/public-envelopes-full/' + key] = null;
  firebase.database().ref().update(updates, function(error) {
    if (error) {
      window.alert(`You're not authorised to delete this envelope`)
    } else {
      // console.log('DELETE SUCCESSFUL!')
    }
  })
}

export function firebaseToRealArray(fbArray) {
  var height;
  if (typeof fbArray === "undefined") {
    return fbArray
  } else if (Array.isArray(fbArray) || typeof fbArray === "undefined") {
    height = fbArray.length;
  } else {
    var keyss = Object.keys(fbArray);
    height = +keyss[keyss.length - 1] + 1;
  }
  var resultArray = [];
  var maxLength = _maxLength(fbArray, height)
  for (var i = 0; i < height; i++) {
    if (typeof fbArray[i] === "undefined") {
      resultArray.push(_objToArray(fbArray[i], maxLength))
    } else {
      resultArray.push(_objToArray(fbArray[i], maxLength))
    }
  }
  return resultArray;
}

function _maxLength(arr, height) {
  var maxLength = 0;
  for (var i = 0; i < height; i++) {
    if (Array.isArray(arr[i])) {
      maxLength = Math.max(maxLength, arr[i].length)
    } else if (typeof arr[i] === "undefined") {
      maxLength = Math.max(maxLength, 0);
    } else {
      maxLength = Math.max(maxLength, +Object.keys(arr[i])[Object.keys(arr[i]).length - 1]);
    }
  }
  return maxLength + 1
}

function _objToArray(obj, l) {
  if (typeof obj === "undefined") {
    return _createArray(l, null)
  }
  var resArray = [];
  for (var i = 0; i < l; i++) {
    if (typeof obj[i] === "undefined") {
      resArray.push(null);
    } else {
      resArray.push(obj[i]);
    }
  }
  return resArray
}

function _createArray(len, itm) {
    var arr1 = [itm],
        arr2 = [];
    while (len > 0) {
        if (len & 1) arr2 = arr2.concat(arr1);
        arr1 = arr1.concat(arr1);
        len >>>= 1;
    }
    return arr2;
}

export function sendToPostOffice(method, historyKey, envelope) {
  var ref = firebase.database().ref();
  if (firebase.auth().currentUser === null) {
    return new Promise((resolve, reject) => {
      resolve({
        status: "unauthenticated"
      })
    })
  }

  var newEnvelope;
  if (method !== "delete") {
    newEnvelope       = envelope;
    newEnvelope.type      = method === "host" ? "host" : "envelope";
    newEnvelope.method    = method;
    // newEnvelope.isPublic  = true;
    newEnvelope.forked    = !envelope.forked ? method === "fork" ? historyKey : false : envelope.forked;
    newEnvelope.authorId  = firebase.auth().currentUser.uid;
  } else {
    newEnvelope = {
      type:               "envelope",
      authorId:           firebase.auth().currentUser.uid,
      method
    }
  }


  // ////////////////////////////////////
  // ////////////////////////////////////
  // ////////////////////////////////////
  // if (method === "host") {
  //   return ref.child('_post-office/' + historyKey).update({
  //     type: "host",
  //     authorId: firebase.auth().currentUser.uid
  //   })
  //     .then(err => {
  //       return err ? { status: "error", err } : { status: "success", historyKey }
  //     })
  // }
  // ////////////////////////////////////
  // ////////////////////////////////////
  // ////////////////////////////////////
  // ////////////////////////////////////


  var key;
  if (method === "update" || method === "delete" || method === "host") {
    key = historyKey
  } else {
    key = ref.child('_post-office').push().key;
  }

  return ref.child('_post-office/' + key).update(newEnvelope)
    .then(err => {
      return err ? { status: "error", err } : { status: "success", key }
      // if (err) {
      //   return { status: "error", err }
      // } else {
      //   return { status: "success", key }
      // }
    })
}



// WEBPACK FOOTER //
// ./src/helpers/fireHelper.js